import React, { useState, useEffect } from 'react';
import { formatDistanceToNow, isPast, differenceInSeconds } from 'date-fns';

export const CountdownTimer = ({ deadline, onExpire, label = 'Time remaining' }) => {
  const [timeLeft, setTimeLeft] = useState('');
  const [isExpired, setIsExpired] = useState(false);
  const [urgency, setUrgency] = useState('normal'); // 'normal', 'warning', 'critical'

  useEffect(() => {
    if (!deadline) return;

    const updateTimer = () => {
      const deadlineDate = new Date(deadline);

      if (isPast(deadlineDate)) {
        setIsExpired(true);
        setTimeLeft('Expired');
        if (onExpire) onExpire();
        return;
      }

      const secondsLeft = differenceInSeconds(deadlineDate, new Date());

      // Set urgency levels
      if (secondsLeft < 300) { // Less than 5 minutes
        setUrgency('critical');
      } else if (secondsLeft < 1800) { // Less than 30 minutes
        setUrgency('warning');
      } else {
        setUrgency('normal');
      }

      setTimeLeft(formatDistanceToNow(deadlineDate, { addSuffix: false }));
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [deadline, onExpire]);

  if (!deadline) {
    return null;
  }

  const urgencyStyles = {
    normal: 'text-gray-600 bg-gray-100',
    warning: 'text-yellow-700 bg-yellow-100',
    critical: 'text-red-700 bg-red-100 animate-pulse',
  };

  return (
    <div className={`inline-flex items-center px-3 py-1.5 rounded-lg ${urgencyStyles[urgency]}`}>
      <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span className="text-sm font-medium">
        {label}: {isExpired ? 'Expired' : timeLeft}
      </span>
    </div>
  );
};
